import React from 'react';
import { Form } from 'react-bootstrap';

const OnTheSelector = ({ option, setOption, showSpecialDays = false }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <Form.Label htmlFor="on-the-select" className="fw-bold text-white mb-1 mb-0"></Form.Label>
      <Form.Group className="d-flex flex-row align-items-center gap-2">
        <Form.Select
          id="on-the-select"
          value={option.first}
          onChange={(e) => setOption({ ...option, first: e.target.value })}
          className="bg-dark text-white border-secondary w-auto"
          style={{ minWidth: 180 }}
        >
          <option value="first">First</option>
          <option value="second">Second</option>
          <option value="third">Third</option>
          <option value="fourth">Fourth</option>
          <option value="fifth">Fifth</option>
          <option value="nexttolast">Next to Last</option>
          <option value="last">Last</option>
        </Form.Select>
        <Form.Select
          id="on-the-day-select"
          value={option.day}
          onChange={(e) => setOption({ ...option, day: e.target.value })}
          className="bg-dark text-white border-secondary w-auto"
          style={{ minWidth: 180 }}
        >
          <option value="sunday">Sunday</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
          <option value="saturday">Saturday</option>
          {showSpecialDays && (
            <>
              <option value="day">Day</option>
              <option value="weekday">Weekday</option>
              <option value="weekendday">Weekend Day</option>
            </>
          )}
        </Form.Select>
      </Form.Group>
    </div>
  );
};

export default OnTheSelector;
